import React from "react";

const TakenVendorEmployeeIdError = () => (
  <div className="error-container">
    <h1 className="error-header">{"409."}</h1>
    <div className="error-content">
      <h3>{"This survey has already been completed."}</h3>
      <p>
        {
          "Technical information for developers: The vendor employee id parameter value for this survey has already been taken."
        }
      </p>
    </div>
  </div>
);
export default TakenVendorEmployeeIdError;



// WEBPACK FOOTER //
// ./src/components/TakenVendorEmployeeIdError.js